const lightTheme = {
  primary: 'rgba(18, 34, 48, 1)',
  text: 'rgba(58,52,51,1)',
  textSecondary: 'rgba(58,52,51,0.7)',
  background: 'rgba(242, 242, 242, 1)',
  backgroundVariant: 'rgba(230,230,230,1)',
  border: 'rgba(58,52,51,0.12)',
  borderLight: 'rgba(58,52,51,0.05)',
  buttonColor: 'rgba(25, 45, 62, 1)',
  buttonFont: 'rgba(255,255,255,1)',
  containerBackground: 'rgba(250, 250, 250, 1)',
  hightlight: '#61dafb',
  pending: 'rgba(255, 225, 120, 0.8)',
  pendingWorkList: 'rgba(230, 45, 45)',
  complete: 'rgba(0, 215, 114, 0.8)',
};


export type Theme = typeof lightTheme;

export const themes = {
  light: lightTheme,
};

export const commonStyle = {
  boxShadow: '1px 2px 1px -1px rgb(0 0 0 / 20%), 1px 1px 1px 1px rgb(0 0 0 / 14%), 1px 1px 3px 1px rgb(0 0 0 / 12%)'
}